import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private apiUrl = environment.apiBaseUrl;
  private tokenKey = 'x-access-token';
  private userKey = 'user-data';

  constructor(private http: HttpClient) {}

  // Get roles from stored user data
  getUserRoles(): string[] {
    const userData = this.getUserData();
    if (userData && userData.roles) {
      return userData.roles;
    }
    return [];
  }

  // Get user data from localStorage
  private getUserData(): any {
    const userDataStr = localStorage.getItem(this.userKey);
    if (!userDataStr) {
      return null;
    }
    try {
      return JSON.parse(userDataStr);
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  }

  // Check if user has a specific role
  hasRole(role: string): boolean {
    const roles = this.getUserRoles();
    return roles.includes(role);
  }

  // Check if user is a super admin
  isSuperAdmin(): boolean {
    return this.hasRole('ROLE_SUPERADMIN');
  }

  // JWT helpers
  private getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }
} 